//#region ../../node_modules/.pnpm/@myparcel+ts-utils@1.13.1/node_modules/@myparcel/ts-utils/lib/index.js
function e(e, t) {
	return e?.[t] !== void 0;
}
//#endregion
//#region ../../node_modules/.pnpm/@myparcel+sdk@4.4.2/node_modules/@myparcel/sdk/lib/index.js
var t = Object.defineProperty, n = (e, n, r) => n in e ? t(e, n, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: r
}) : e[n] = r, r = (e, t, r) => n(e, typeof t == "symbol" ? t : t + "", r), i = class {
	constructor() {
		r(this, "fns"), this.fns = [];
	}
	delete(e) {
		let t = this.fns.indexOf(e);
		t !== -1 && (this.fns = [...this.fns.slice(0, t), ...this.fns.slice(t + 1)]);
	}
	use(e) {
		this.fns = [...this.fns, e];
	}
}, a = class e extends Error {
	constructor(t) {
		super(t), r(this, "name", "user"), Object.setPrototypeOf(this, e.prototype), this.name = "UserException";
	}
}, o = class e extends Error {
	constructor(t) {
		super(t.message), r(this, "data"), Object.setPrototypeOf(this, e.prototype), this.name = "ApiException", this.data = t;
	}
}, s = (e, t) => {
	if (t) {
		let n = Object.entries(t).map(([e, t]) => `${e}=${t}`);
		n.length && (e += `?${n.join("&")}`);
	}
	return e;
}, c = ["POST", "PUT"], l = class {
	constructor(e) {
		r(this, "interceptors"), r(this, "baseUrl"), r(this, "headers"), r(this, "parameters"), r(this, "options"), r(this, "_requiredHeaders", []), this.baseUrl = (e?.baseUrl ?? "https://api.myparcel.nl").replace(/\/+$/, ""), this.headers = e?.headers ?? {}, this.parameters = e?.parameters ?? {}, this.options = e?.options ?? {}, this.interceptors = {
			request: new i(),
			response: new i()
		};
	}
	get requiredHeaders() {
		return this._requiredHeaders;
	}
	set requiredHeaders(e) {
		this._requiredHeaders = e;
	}
	async doRequest(t, n) {
		let r = this.normalizeOptions(t, {
			...n,
			...this.options
		});
		this.validateHeaders(t, r);
		let i = await this.request(t, r);
		for (let e of this.interceptors.response.fns) i = await e(i);
		if (e(i, "errors")) throw new o(i);
		return this.getResponseBody(t, i);
	}
	getResponseBody(t, n) {
		if (!e(n, "data")) return n;
		let r = t.getResponseProperty();
		if (!r) return n.data;
		let { page: i, size: a, results: o } = n.data;
		return i === void 0 && a === void 0 && o === void 0 ? n.data[r] : {
			[r]: n.data[r],
			...i !== void 0 && { page: i },
			...a !== void 0 && { size: a },
			...o !== void 0 && { results: o }
		};
	}
	getHeaders() {
		return {
			Accept: "application/json",
			...this.headers
		};
	}
	createUrl(e, t) {
		let n = e.getPath();
		if (n.length && !n.startsWith("/") && (n = `/${n}`), t != null && t.path && (n = this.substitutePath(n, t.path)), n.includes("/:")) throw new a(`One or more path variables are missing in ${n}`);
		return t != null && t.parameters && (n = s(n, t.parameters)), this.baseUrl + n;
	}
	substitutePath(e, t) {
		return t && Object.entries(t).forEach(([t, n]) => {
			e = e.replace(`:${t}`, String(n));
		}), e.includes(":") && e.match(/:\w+?\?/g)?.forEach((t) => {
			e = e.replace(`/${t}`, "");
		}), e;
	}
	validateHeaders(e, t) {
		let n = Object.entries(t.headers).reduce((e, [t, n]) => ({
			...e,
			[t.toLowerCase()]: n
		}), {}), r = this.requiredHeaders.filter((e) => !(e.toLowerCase() in n));
		if (r.length) throw new a(`Required headers are missing: ${r.join(", ")}`);
	}
	normalizeOptions(t, n) {
		let r = {
			...n,
			parameters: {
				...this.parameters,
				...n.parameters,
				...t.getParameters()
			},
			headers: {
				...c.includes(t.method) ? { "Content-Type": "application/json" } : {},
				...this.getHeaders(),
				...n.headers,
				...t.getHeaders()
			}
		};
		if (e(n, "body")) {
			let e = t.getProperty();
			if (n.body instanceof FormData) return r.body = n.body, delete r.headers["Content-Type"], r;
			e === void 0 ? r.body = { data: n.body } : r.body = { data: { [e]: n.body } };
		}
		return r;
	}
}, ee = (e) => {
	try {
		return JSON.parse(e), !0;
	} catch {
		return !1;
	}
}, te = class extends l {
	constructor(t) {
		super(t), r(this, "request", async (t, n) => {
			var r, i, a;
			for (let e of this.interceptors.request.fns) n = await e(n);
			let o = t.getTimeout() ?? n.timeout, s = new AbortController(), c = {
				method: t.method,
				headers: n.headers,
				signal: s.signal
			}, l;
			o && (l = setTimeout(() => {
				s.abort();
			}, o)), e(n, "body") && (n.body instanceof FormData ? c.body = n.body : c.body = JSON.stringify(n.body));
			try {
				let e = await fetch(this.createUrl(t, n), c);
				if (e.body) {
					if ((r = e.headers.get("Content-Disposition")) != null && r.includes("attachment") || (i = e.headers.get("Content-Type")) != null && i.includes("application/pdf")) return e.blob();
					let t = await e.text();
					return (a = e.headers.get("Content-Type")) != null && a.includes("application/json") && ee(t) ? JSON.parse(t) : t;
				}
			} finally {
				l && clearTimeout(l);
			}
		});
	}
}, ne = class {
	constructor(e) {
		r(this, "method", "GET"), r(this, "property"), r(this, "responseProperty"), r(this, "timeout"), r(this, "headers"), r(this, "parameters"), this.headers = e?.headers ?? {}, this.parameters = e?.parameters ?? {};
	}
	getHeaders() {
		return this.headers;
	}
	getParameters() {
		return this.parameters;
	}
	getPath() {
		return this.path;
	}
	getProperty() {
		return this.property;
	}
	getResponseProperty() {
		return this.responseProperty ?? this.property;
	}
	getTimeout() {
		return this.timeout;
	}
}, u = class extends ne {}, d = class extends ne {};
function re(e, t) {
	if (!t.length) throw new a("At least one endpoint must be passed.");
	return {
		...t.reduce((t, n) => ({
			...t,
			[n.name]: async (t) => e.doRequest(n, t ?? {})
		}), {}),
		client: e
	};
}
var ie = (e, t) => (e.requiredHeaders = ["Authorization"], re(e, t)), ae = (e, t) => re(e, t), oe = class extends u {
	name = "getAccountActiveBrackets";
	path = "accounts/:account_id/active_brackets";
	property = "active_brackets";
}, se = class extends u {
	name = "getAccountBrackets";
	path = "account_brackets";
	property = "account_brackets";
}, ce = class extends u {
	method = "PUT";
	name = "putAccountBrackets";
	path = "account_brackets";
	property = "account_brackets";
}, le = class extends u {
	method = "POST";
	name = "postAccountCarrierOptions";
	path = "accounts/:shop_id/carrier_options";
	property = "carrier_options";
}, ue = class extends u {
	method = "DELETE";
	name = "deleteAccountCarrierOption";
	path = "accounts/:account_id/carrier_options/:carrier_options_id";
	property = "carrier_options";
}, de = class extends u {
	method = "DELETE";
	name = "deleteAccountMessage";
	path = "account_messages/:id";
	property = "messages";
}, fe = class extends u {
	name = "getAccountMessages";
	path = "account_messages";
	property = "messages";
}, pe = class extends u {
	method = "DELETE";
	name = "deleteAccountProductPrices";
	path = "account_product_prices/:price_id";
}, me = class extends u {
	name = "getAccountProductPrices";
	path = "account_product_prices";
	property = "account_products";
}, he = class extends u {
	method = "POST";
	name = "postAccountProductPrices";
	path = "account_product_prices";
	property = "account_product_prices";
	responseProperty = "prices";
}, ge = class extends u {
	name = "getAccountSupportCases";
	path = "accounts/:id/support_cases";
	property = "support_cases";
}, _e = {
	Requested: "requested",
	Active: "active",
	Cancelled: "cancelled",
	Inactive: "inactive"
}, ve = class extends u {
	name = "getAccount";
	path = "accounts/:id";
	property = "accounts";
	timeout = 2e4;
}, ye = class extends u {
	name = "getAccounts";
	path = "accounts";
	property = "accounts";
	timeout = 2e4;
}, be = class extends u {
	method = "PUT";
	name = "putAccount";
	path = "accounts";
	property = "accounts";
}, xe = class extends u {
	method = "POST";
	name = "postAccountsAnonymize";
	path = "accounts/anonymize";
	property = "anonymize_accounts";
}, Se = class extends u {
	method = "GET";
	name = "getAcl";
	path = "acl";
}, Ce = class extends u {
	name = "getAclRolesCustomer";
	path = "acl/roles/customer";
	property = "roles";
}, we = class extends u {
	name = "getAclRolesAdmin";
	path = "acl/roles/admin";
	property = "roles";
}, Te = class extends u {
	method = "DELETE";
	name = "deleteAddress";
	path = "addresses/:id";
	property = "addresses";
}, Ee = class extends u {
	method = "DELETE";
	name = "deleteAddresses";
	path = "addresses/:ids";
	property = "addresses";
}, De = class extends u {
	name = "getAddress";
	path = "addresses/:id";
	property = "addresses";
}, Oe = class extends u {
	name = "getAddresses";
	path = "addresses";
	property = "addresses";
}, ke = class extends u {
	method = "POST";
	name = "postAddress";
	path = "addresses";
	property = "addresses";
	responseProperty = "ids";
}, Ae = class extends u {
	method = "PUT";
	name = "putAddress";
	path = "addresses";
	property = "addresses";
}, je = class extends u {
	method = "POST";
	name = "postMarkCreditInvoices";
	path = "admin/actions/mark_credit_invoices";
	property = "mark_credit_invoices";
}, Me = class extends u {
	name = "getAnalyticsDashboards";
	path = "auth/cumulio/token";
}, Ne = class extends u {
	name = "getApiKeys";
	path = "keys";
	property = "api_keys";
}, Pe = class extends u {
	method = "POST";
	name = "postApiKeys";
	path = "keys";
	property = "api_keys";
}, Fe = class extends u {
	name = "getBaseProductPrices";
	path = "base_product_prices";
	property = "base_products";
}, Ie = class extends u {
	name = "getSepaInstructions";
	path = "billing/sepa_instructions";
	method = "GET";
}, Le = class extends u {
	name = "postSepaInstructionsCredit";
	path = "billing/sepa_instructions/credit";
	method = "POST";
}, Re = class extends u {
	name = "postSepaInstructionsDebit";
	path = "billing/sepa_instructions/debit";
	method = "POST";
}, ze = class extends u {
	name = "postEmailCollectionAgencyReport";
	path = "billing/email_collection_agency_report";
	method = "POST";
}, f = class extends u {
	name = "postEmailUnpaidInvoices";
	path = "billing/email_unpaid_invoices";
	method = "POST";
}, p = class extends u {
	name = "getBillingMethods";
	path = "shops/:shop_id/billing_methods";
	property = "billing_methods";
}, m = class extends u {
	name = "getBracketRanges";
	path = "bracket_ranges/:platform_id";
}, Be = class extends u {
	name = "getBrackets";
	path = "brackets/:platform_id";
}, Ve = class extends u {
	method = "POST";
	name = "postBrandingBannerImage";
	path = "shops/:shop_id/images/branding_banner";
	property = "branding_banner";
	responseProperty = "ids";
}, He = class extends u {
	method = "DELETE";
	name = "deleteBrandingBannerImage";
	path = "shops/:shop_id/images/branding_banner";
	property = "branding_banner";
}, Ue = class extends u {
	name = "getCarrierConfigurations";
	path = "shops/:shop_id/carrier_configurations";
	property = "carrier_configurations";
}, We = class extends u {
	method = "POST";
	name = "postCarrierConfiguration";
	path = "shops/:shop_id/carriers/:carrier_id/carrier_configuration";
	property = "carrier_configurations";
}, Ge = class extends u {
	method = "DELETE";
	name = "deleteCarrierOption";
	path = "accounts/:account_id/carrier_options/:contract_id";
	property = "carrier_options";
}, Ke = class extends u {
	name = "getCarrierOptions";
	path = "carrier_management/accounts/:account_id/carrier_options";
	property = "carrier_options";
}, qe = class extends u {
	method = "POST";
	name = "postCarrierOptions";
	path = "accounts/:account_id/carrier_options";
	property = "carrier_options";
	responseProperty = "ids";
}, Je = class extends u {
	method = "PUT";
	name = "putCarrierOptions";
	path = "carrier_management/accounts/:account_id/carrier_options";
	property = "carrier_options";
}, Ye = class extends u {
	method = "DELETE";
	name = "deleteCollectTrip";
	path = "collect_trip/:id";
	property = "collect_trip";
}, Xe = class extends u {
	method = "DELETE";
	name = "deleteCollectTripSchedule";
	path = "collect_trip_schedule/:id";
	property = "collect_trip";
}, Ze = class extends u {
	name = "getCollectTripDisabledDays";
	path = "collect_trip_disabled_days";
}, Qe = class extends u {
	name = "getCollectTripSchedules";
	path = "collect_trip_schedule";
}, $e = class extends u {
	name = "getCollectTrips";
	path = "collect_trip";
}, et = class extends u {
	method = "POST";
	name = "postConnectAffiliates";
	path = "connect_affiliates";
	property = "affiliates";
}, tt = class extends u {
	name = "getCheckSubdomain";
	path = "consumer_portal/check_subdomain";
	property = "branding_banner";
}, nt = class extends u {
	name = "getConsumerPortalFields";
	path = "consumer_portal/fields/:shop_id";
	property = "fields";
}, rt = class extends u {
	method = "PUT";
	name = "putConsumerPortalFields";
	path = "consumer_portal/fields";
	property = "fields";
}, it = class extends u {
	name = "getDeliveryOptions";
	path = "delivery_options";
	property = "deliveries";
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/json;charset=utf-8;version=2.0"
		};
	}
}, at = class extends u {
	name = "getDimensionsPresets";
	path = "dimensions_presets";
	property = "dimensions_presets";
}, ot = class extends u {
	name = "getDimensionsPreset";
	path = "dimensions_presets/:id";
	property = "dimensions_presets";
}, st = class extends u {
	method = "PATCH";
	name = "patchDimensionsPresets";
	path = "dimensions_presets";
	property = "dimensions_presets";
}, ct = class extends u {
	method = "POST";
	name = "postDimensionsPresets";
	path = "dimensions_presets";
	property = "dimensions_presets";
}, lt = class extends u {
	method = "PUT";
	name = "putDimensionsPresets";
	path = "dimensions_presets";
	property = "dimensions_presets";
}, ut = class extends u {
	method = "DELETE";
	name = "deleteDimensionsPresets";
	path = "dimensions_presets/:id";
	property = "dimensions_presets";
}, dt = class extends u {
	name = "getDirectDebitBanks";
	path = "direct_debit_banks";
	property = "banks";
}, ft = class extends u {
	name = "getDirectDebitMandate";
	path = "shops/:shop_id/direct_debit_mandate";
	property = "mandates";
}, pt = class extends u {
	method = "POST";
	name = "postDirectDebitMandate";
	path = "shops/:shop_id/direct_debit_mandate";
}, mt = class extends u {
	method = "DELETE";
	name = "deleteDirectDebitMandate";
	path = "shops/:shop_id/direct_debit_mandate";
}, ht = class extends u {
	name = "getDropOffPoints";
	path = "carriers/:carrier_id/drop_off_points";
	property = "drop_off_points";
}, gt = class extends u {
	name = "getEmails";
	path = "emails";
	property = "email_templates";
}, _t = class extends u {
	method = "PUT";
	name = "putEmail";
	path = "emails";
	property = "email_templates";
}, vt = class extends u {
	name = "getEoriNumberCheck";
	path = "eori_number/check";
	responseProperty = "valid";
}, yt = class extends u {
	method = "DELETE";
	name = "deleteExternalIntegrationsProviderCredentialsAmazon";
	path = "external_integration_provider_credentials/amazon/:id";
	property = "credentials";
}, bt = class extends u {
	name = "getExternalIntegrationsProviderCredentialsAmazon";
	path = "external_integration_provider_credentials/amazon";
	property = "credentials";
}, xt = class extends u {
	method = "POST";
	name = "postExternalIntegrationsProviderCredentialsAmazon";
	path = "external_integration_provider_credentials/amazon/selling_partner";
	property = "credentials";
	responseProperty = "redirect_url";
}, St = class extends u {
	method = "PUT";
	name = "putExternalIntegrationsProviderCredentialsAmazon";
	path = "external_integration_provider_credentials/amazon";
	property = "credentials";
	responseProperty = "ids";
}, Ct = class extends u {
	name = "getExternalIntegrationsProviderCredentialsBol";
	path = "external_integration_provider_credentials/bol_dot_com/v3";
	property = "credentials";
}, wt = class extends u {
	method = "POST";
	name = "postExternalIntegrationsProviderCredentialsBol";
	path = "external_integration_provider_credentials/bol_dot_com/v3";
	property = "credentials";
	responseProperty = "redirect_url";
}, Tt = class extends u {
	method = "DELETE";
	name = "deleteExternalIntegrationsProviderCredentialsBol";
	path = "external_integration_provider_credentials/bol_dot_com/:id";
	property = "credentials";
}, Et = class extends u {
	method = "PUT";
	name = "putExternalIntegrationsProviderCredentialsBol";
	path = "external_integration_provider_credentials/bol_dot_com/v3";
	property = "credentials";
	responseProperty = "ids";
}, Dt = class extends u {
	name = "getExternalIntegrationsProviderCredentialsEtsy";
	path = "external_integration_provider_credentials/etsy";
	property = "credentials";
}, Ot = class extends u {
	method = "POST";
	name = "postExternalIntegrationsProviderCredentialsEtsy";
	path = "external_integration_provider_credentials/etsy";
	property = "credentials";
	responseProperty = "redirect_url";
}, kt = class extends u {
	method = "DELETE";
	name = "deleteExternalIntegrationsProviderCredentialsEtsy";
	path = "external_integration_provider_credentials/etsy/:id";
	property = "credentials";
}, At = class extends u {
	method = "PUT";
	name = "putExternalIntegrationsProviderCredentialsEtsy";
	path = "external_integration_provider_credentials/etsy";
	property = "credentials";
	responseProperty = "ids";
}, jt = class extends u {
	name = "getExternalIntegrationsProviderCredentialsExact";
	path = "external_integration_provider_credentials/exact";
	property = "credentials";
}, Mt = class extends u {
	method = "POST";
	name = "postExternalIntegrationsProviderCredentialsExact";
	path = "external_integration_provider_credentials/exact";
	property = "credentials";
	responseProperty = "redirect_url";
}, Nt = class extends u {
	method = "DELETE";
	name = "deleteExternalIntegrationsProviderCredentialsExact";
	path = "external_integration_provider_credentials/exact/:id";
	property = "credentials";
}, Pt = class extends u {
	method = "PUT";
	name = "putExternalIntegrationsProviderCredentialsExact";
	path = "external_integration_provider_credentials/exact";
	property = "credentials";
	responseProperty = "ids";
}, Ft = class extends u {
	name = "getExternalIntegrationsProviderCredentialsExactDe";
	path = "external_integration_provider_credentials/exact_de";
	property = "credentials";
}, It = class extends u {
	method = "POST";
	name = "postExternalIntegrationsProviderCredentialsExactDe";
	path = "external_integration_provider_credentials/exact_de";
	property = "credentials";
	responseProperty = "redirect_url";
}, Lt = class extends u {
	method = "DELETE";
	name = "deleteExternalIntegrationsProviderCredentialsExactDe";
	path = "external_integration_provider_credentials/exact_de/:id";
	property = "credentials";
}, Rt = class extends u {
	method = "PUT";
	name = "putExternalIntegrationsProviderCredentialsExactDe";
	path = "external_integration_provider_credentials/exact_de";
	property = "credentials";
	responseProperty = "ids";
}, zt = class extends u {
	method = "POST";
	name = "postExternalIntegration";
	path = "auth/external_integration/:provider";
}, Bt = class extends u {
	name = "getExternalIntegrationsProviderCredentialsWix";
	path = "external_integration_provider_credentials/wix";
	property = "credentials";
}, Vt = class extends u {
	method = "POST";
	name = "postExternalIntegrationsProviderCredentialsWix";
	path = "external_integration_provider_credentials/wix";
	property = "credentials";
	responseProperty = "redirect_url";
}, Ht = class extends u {
	method = "DELETE";
	name = "deleteExternalIntegrationsProviderCredentialsWix";
	path = "external_integration_provider_credentials/wix/:id";
	property = "credentials";
}, Ut = class extends u {
	method = "PUT";
	name = "putExternalIntegrationsProviderCredentialsWix";
	path = "external_integration_provider_credentials/wix";
	property = "credentials";
	responseProperty = "ids";
}, Wt = class extends u {
	method = "POST";
	name = "postFulfilmentDisable";
	path = "fulfilment/settings/disable";
	property = "fulfilment";
}, Gt = class extends u {
	method = "POST";
	name = "postFulfilmentDisableAutosplit";
	path = "fulfilment/settings/autosplit/disable";
	property = "fulfilment";
}, Kt = class extends u {
	method = "POST";
	name = "postFulfilmentDisablePicqer";
	path = "fulfilment/settings/picqer/disable";
	property = "fulfilment";
}, qt = class extends u {
	method = "POST";
	name = "postFulfilmentEnable";
	path = "fulfilment/settings/enable";
	property = "fulfilment";
}, Jt = class extends u {
	method = "POST";
	name = "postFulfilmentEnableAutosplit";
	path = "fulfilment/settings/autosplit/enable";
	property = "fulfilment";
}, Yt = class extends u {
	method = "POST";
	name = "postFulfilmentEnablePicqer";
	path = "fulfilment/settings/picqer/enable";
	property = "fulfilment";
}, Xt = class extends u {
	method = "POST";
	name = "postFulfilmentMode";
	path = "fulfilment/settings/fulfilment-mode";
	property = "fulfilment";
}, Zt = [
	new qt(),
	new Wt(),
	new Kt(),
	new Yt(),
	new Xt(),
	new Jt(),
	new Gt()
], Qt = class extends u {
	name = "getImplications";
	path = "shops/:shop_id/shipping_rules/implications";
	property = "implications";
}, $t = class extends u {
	method = "POST";
	name = "postInterimInvoices";
	path = "interim_invoices";
	property = "interim_invoice_requests";
	responseProperty = "ids";
}, en = class extends u {
	name = "getInterimInvoices";
	path = "pro_forma/:shop_ids";
	property = "proforma_invoices";
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/json;charset=utf-8"
		};
	}
}, tn = class extends u {
	name = "getInvitations";
	path = "invitations";
	property = "invitations";
}, nn = class extends u {
	method = "POST";
	name = "postInvitation";
	path = "invitations";
	property = "invitations";
	responseProperty = "ids";
}, rn = class extends u {
	method = "PUT";
	name = "putInvitation";
	path = "invitations";
	property = "invitations";
}, an = class extends u {
	name = "getInvoices";
	path = "invoices";
	property = "invoices";
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.invoice_normal+json"
		};
	}
}, on = class extends u {
	name = "getInvoiceDetails";
	path = "pro_forma/:shop_id";
	timeout = 2e5;
	/* c8 ignore next 7 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.invoice+pdf",
			"Content-Type": "application/vnd.invoice+pdf"
		};
	}
}, sn = class extends u {
	name = "getInvoiceItemCategories";
	path = "billing/invoice_item_categories";
	property = "invoice_item_categories";
}, cn = class extends u {
	method = "POST";
	name = "postInvoiceItems";
	path = "invoice_items";
	property = "invoice_items";
}, ln = class extends u {
	method = "POST";
	name = "postSurchargeUploadUrl";
	path = "surcharges/upload-url";
	property = "";
}, un = class extends u {
	method = "POST";
	name = "postSpecialInvoices";
	path = "special_invoices";
	property = "invoice_items";
}, dn = class extends u {
	method = "PUT";
	name = "putInvoices";
	path = "invoices";
	property = "invoices";
}, fn = class extends u {
	name = "getInvoiceDetailLegacyAttachment";
	path = "invoices/:invoice_id";
	property = "pdfs";
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/json.invoice_detailed_pdf_link+json"
		};
	}
}, pn = class extends u {
	name = "getInvoiceCsvAttachment";
	path = "invoices/:invoice_id";
	response = "pdfs";
	timeout = 2e5;
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.invoice_detailed+csv;version=2.0"
		};
	}
}, mn = class extends u {
	name = "getInvoiceDetailAttachment";
	path = "invoices/:invoice_id";
	responseProperty = "pdfs";
	/* c8 ignore next 7 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.invoice_pdf_link+json"
		};
	}
}, hn = class extends u {
	name = "getInvoiceShortAttachment";
	path = "invoices/:invoice_id";
	responseProperty = "pdfs";
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/json.invoice_normal_pdf_link+json"
		};
	}
}, gn = class extends u {
	name = "getLabelPackagesStatus";
	path = "label_packages_status";
	property = "label_packages_status";
}, _n = class extends u {
	method = "POST";
	name = "postProcessLabelPackages";
	path = "process_label_packages";
	property = "ids";
}, vn = class extends u {
	method = "POST";
	name = "postLabelPackages";
	path = "label_packages";
	property = "label_packages";
}, yn = class extends u {
	name = "getLocations";
	path = "locations";
	property = "locations";
}, bn = class extends u {
	name = "getPackagings";
	path = "woocommerce/order";
	property = "orders";
}, xn = class extends u {
	method = "POST";
	name = "postPackaging";
	path = "woocommerce/order";
	property = "orders";
	responseProperty = "ids";
}, Sn = class extends u {
	name = "postPaymentInstructions";
	path = "billing/payment_instructions";
	property = "payment_instruction_requests";
	responseProperty = "payment_instructions";
	method = "POST";
}, Cn = class extends u {
	name = "getPaymentGateways";
	path = "payment_gateways";
	property = "payment_gateways";
}, wn = class extends u {
	name = "getPickupLocations";
	path = "pickup_locations";
	property = "pickup_locations";
}, Tn = class extends u {
	name = "getProductPrice";
	path = "product_price";
	property = "price";
}, En = class extends u {
	name = "checkPostalCode";
	path = "postal_code/check";
	property = "postal_code";
}, Dn = class extends u {
	name = "getPriceScaleBrackets";
	path = "accounts/:id/active_brackets/:carrierId";
	property = "active_brackets";
	timeout = 2e5;
}, On = class extends u {
	name = "getPhoneNumberCheck";
	path = "/phone_number/check";
	property = "phone_number";
}, kn = class extends u {
	method = "POST";
	name = "postShipmentCarrierPrice";
	path = "shipments/carrier_price";
	property = "shipments";
	responseProperty = "carrier_price";
}, An = class extends u {
	name = "getShipment";
	path = "shipments/:id";
	property = "shipments";
}, jn = class extends u {
	name = "getShipments";
	path = "shipments";
	property = "shipments";
}, Mn = class extends u {
	method = "POST";
	name = "postShipments";
	path = "shipments";
	property = "shipments";
	responseProperty = "ids";
	/* c8 ignore start */
	getHeaders() {
		return {
			...super.getHeaders(),
			"Content-Type": "application/vnd.shipment+json;charset=utf-8;version=1.1"
		};
	}
}, Nn = class extends u {
	name = "getShippingRules";
	path = "shipping_rules";
	property = "shipping_rules";
}, Pn = class extends u {
	method = "PATCH";
	name = "patchShippingRule";
	path = "shipping_rules";
	property = "shipping_rules";
}, Fn = class extends u {
	method = "POST";
	name = "postShippingRule";
	path = "shipping_rules";
	property = "shipping_rules";
}, In = class extends u {
	method = "PUT";
	name = "putShippingRule";
	path = "shipping_rules";
	property = "shipping_rules";
}, Ln = class extends u {
	method = "DELETE";
	name = "deleteShippingRule";
	path = "shipping_rules/:id";
	property = "shipping_rules";
}, Rn = class extends u {
	name = "getShopAccess";
	path = "shop_access";
	property = "shop_access";
}, zn = class extends u {
	method = "POST";
	name = "postShopAccess";
	path = "shop_access";
	property = "shop_access";
}, Bn = class extends u {
	name = "getShopCarrierOptions";
	path = "carrier_management/shops/:shop_id/carrier_options";
	property = "carrier_options";
}, Vn = class extends u {
	method = "POST";
	name = "postShopCarrierOptions";
	path = "shops/:shop_id/carrier_options";
	property = "carrier_options";
}, Hn = class extends u {
	method = "PUT";
	name = "putShopCarrierOptions";
	path = "carrier_management/shops/:shop_id/carrier_options";
	property = "carrier_options";
}, Un = class extends u {
	method = "DELETE";
	name = "deleteShopCarrierOption";
	path = "shops/:shop_id/carrier_options/:id";
	property = "carrier_options";
}, Wn = class extends u {
	method = "DELETE";
	name = "deleteShopImageEmail";
	path = "shops/:shop_id/images/email";
	property = "branding_banner";
}, Gn = class extends u {
	method = "POST";
	name = "postShopImageEmail";
	path = "shops/:shop_id/images/email";
	property = "branding_banner";
	responseProperty = "ids";
}, Kn = class extends u {
	name = "getReturnContributions";
	path = "shop_return_contributions";
	property = "return_contributions";
}, qn = class extends u {
	name = "postReturnContributions";
	path = "shop_return_contributions";
	property = "return_contributions";
	method = "POST";
}, Jn = class extends u {
	name = "putReturnContributions";
	path = "shop_return_contributions";
	property = "return_contributions";
	method = "PUT";
}, Yn = class extends u {
	name = "getShopStatistics";
	path = "shops/:shop_id/statistics";
	property = "id";
	responseProperty = "shop_statistics";
}, Xn = class extends u {
	name = "getShop";
	path = "shops/:id";
	property = "shops";
}, Zn = class extends u {
	method = "POST";
	name = "postShopDuplicate";
	path = "shops/duplicate";
	property = "shops";
	responseProperty = "ids";
}, Qn = class extends u {
	method = "PUT";
	name = "putShop";
	path = "shops";
	property = "shops";
}, $n = class extends u {
	name = "getSpecialInvoiceItems";
	path = "special_invoice_items";
	property = "invoice_items";
}, er = class extends u {
	name = "getStatisticsAffiliateCommission";
	path = "statistics_affiliate_commission";
	property = "statistics_affiliate_commission";
}, tr = class extends u {
	name = "getSubscriptionsCapabilities";
	path = "subscriptions/capabilities";
	property = "capabilities";
}, nr = class extends u {
	method = "DELETE";
	name = "deleteSubscription";
	path = "subscriptions/:id";
	property = "subscriptions";
}, rr = class extends u {
	name = "getSubscriptions";
	path = "subscriptions";
	property = "subscriptions";
}, ir = class extends u {
	method = "PATCH";
	name = "patchSubscriptions";
	path = "subscriptions";
	property = "subscriptions";
	responseProperty = "ids";
}, ar = class extends u {
	method = "POST";
	name = "postSubscriptions";
	path = "subscriptions";
	property = "subscriptions";
	responseProperty = "ids";
}, or = class extends u {
	name = "getSupportCase";
	path = "support_cases/:id";
	property = "support_cases";
}, sr = class extends u {
	method = "PUT";
	name = "putSupportCase";
	path = "support_cases";
	property = "support_cases";
}, cr = class extends u {
	name = "getSupportCaseAttachment";
	path = "support_cases/:case_id/attachments/:attachment_id";
}, lr = class extends u {
	method = "POST";
	name = "postSupportCaseComment";
	path = "support_cases/:id/comments";
	property = "comments";
}, ur = class extends u {
	name = "getSupportCaseReturnReasons";
	path = "return_shipment/:shipment_id/return_reasons";
	property = "return_reasons";
}, dr = class extends u {
	name = "getSystemCountryCodes";
	path = "system_country_codes";
	property = "countries";
}, h = class extends u {
	method = "DELETE";
	name = "deleteSystemMessages";
	path = "system_messages/:id";
	property = "messages";
}, fr = class extends u {
	method = "PUT";
	name = "putSystemMessages";
	path = "system_messages";
	property = "messages";
}, pr = class extends u {
	method = "POST";
	name = "postSystemMessages";
	path = "system_messages";
	property = "messages";
}, mr = class extends u {
	name = "getSystemShipmentOptionPrices";
	path = "system_shipment_option_prices";
	property = "shipment_option_prices";
}, hr = class extends u {
	method = "POST";
	name = "postTicket";
	path = "tickets";
	property = "tickets";
}, gr = class extends u {
	method = "POST";
	name = "postTicketAttachment";
	path = "tickets/:case_identifier/attachment";
	property = "file";
}, _r = class extends u {
	name = "getTrackAndTrace";
	path = "tracktraces/:shipment_id";
	property = "tracktraces";
}, vr = class extends u {
	name = "getUiSettings";
	path = "ui_settings/:account_ids";
	property = "ui_settings";
}, yr = class extends u {
	method = "POST";
	name = "postUiSettings";
	path = "ui_settings";
	property = "ui_settings";
}, br = class extends u {
	method = "PUT";
	name = "putUiSettings";
	path = "ui_settings";
	property = "ui_settings";
}, xr = class extends u {
	method = "DELETE";
	name = "deleteUser";
	path = "users/:id";
	property = "users";
}, Sr = class extends u {
	name = "getUser";
	path = "users/:id";
	property = "users";
}, Cr = class extends u {
	name = "getUsers";
	path = "users";
	property = "users";
}, wr = class extends u {
	method = "POST";
	name = "postUsers";
	path = "users";
	property = "users";
}, Tr = class extends u {
	method = "PUT";
	name = "putUsers";
	path = "users";
	property = "users";
}, Er = class extends u {
	method = "POST";
	name = "postSendVerificationEmail";
	path = "send_verification_email";
	property = "send_verification_email";
}, Dr = class extends u {
	method = "DELETE";
	name = "deleteWebhookSubscriptions";
	path = "webhook_subscriptions/:ids";
	property = "webhook_subscriptions";
}, Or = class extends u {
	name = "getWebhookSubscriptions";
	path = "webhook_subscriptions";
	property = "webhook_subscriptions";
}, kr = class extends u {
	method = "POST";
	name = "postWebhookSubscriptions";
	path = "webhook_subscriptions";
	property = "webhook_subscriptions";
	responseProperty = "ids";
}, Ar = class extends d {
	name = "getBranding";
	path = "consumer_portal/branding";
	property = "branding";
}, jr = class extends d {
	name = "getFields";
	path = "consumer_portal/fields";
	property = "fields";
}, Mr = class extends d {
	name = "checkPostalCode";
	path = "postal_code/check";
	property = "postal_code";
}, Nr = class extends d {
	name = "getSocialShippingLinks";
	path = "consumer_portal/social_shipping_links/:uuid";
	property = "social_shipping_links";
}, Pr = class extends d {
	method = "POST";
	name = "postPreRegistration";
	path = "preregistration";
	property = "preregistration";
}, Fr = class extends d {
	method = "POST";
	name = "postRegistration";
	path = "registration";
	property = "registration";
	timeout = 15e3;
}, Ir = class extends d {
	name = "getCompanyProfile";
	path = "kvk/company_profile/:coc_number";
	property = "company_profile";
}, Lr = class extends d {
	name = "getChamberOfCommerceCompanies";
	path = "/kvk/companies";
	property = "companies";
}, Rr = class extends d {
	name = "getCheckShopName";
	path = "/check_shop_name";
}, zr = class extends d {
	name = "getLocations";
	path = "locations";
	property = "locations";
}, Br = [new oe()], Vr = [new se(), new ce()], Hr = [new le(), new ue()], Ur = [new de(), new fe()], Wr = [
	new pe(),
	new me(),
	new he()
], Gr = [new ge()], Kr = [
	new ve(),
	new ye(),
	new be()
], qr = [new xe()], Jr = [new Se()], Yr = [new Ce()], Xr = [new we()], Zr = [
	new Te(),
	new Ee(),
	new De(),
	new Oe(),
	new ke(),
	new Ae()
], Qr = class extends u {
	method = "POST";
	name = "postUpdateBillingMethod";
	path = "admin/actions/update_billing_method";
	property = "update_billing_method";
}, $r = class extends u {
	method = "POST";
	name = "postUpdateInvoiceStatus";
	path = "admin/actions/update_invoice_status";
	property = "update_invoice_status";
}, ei = [
	new je(),
	new Qr(),
	new $r()
], ti = [new Me()], ni = [new Ne(), new Pe()], ri = [new Fe()], ii = [
	new Ie(),
	new ze(),
	new f(),
	new Le(),
	new Re()
], ai = [new p()], oi = [new m()], si = [new Be()], ci = [new Ve(), new He()], li = [new Ue(), new We()], ui = [
	new Ge(),
	new Ke(),
	new qe(),
	new Je()
], di = [
	new Ye(),
	new Xe(),
	new Ze(),
	new Qe(),
	new $e()
], fi = [new et()], pi = [new tt()], mi = [new nt(), new rt()], hi = [new it()], gi = [
	new ut(),
	new ot(),
	new at(),
	new st(),
	new ct(),
	new lt()
], _i = [new dt()], vi = [
	new ft(),
	new pt(),
	new mt()
], yi = [new ht()], bi = [new gt(), new _t()], xi = [new vt()], Si = class extends u {
	method = "GET";
	name = "getExternalIntegration";
	path = "auth/external_integration";
}, Ci = [
	new zt(),
	new Si(),
	new yt(),
	new bt(),
	new xt(),
	new St(),
	new Tt(),
	new Ct(),
	new wt(),
	new Et(),
	new kt(),
	new Dt(),
	new Ot(),
	new At(),
	new Nt(),
	new jt(),
	new Pt(),
	new Mt(),
	new Lt(),
	new Ft(),
	new It(),
	new Rt(),
	new Ht(),
	new Bt(),
	new Vt(),
	new Ut()
], wi = [new Qt()], Ti = [new en(), new $t()], Ei = [
	new tn(),
	new rn(),
	new nn()
], Di = class extends u {
	name = "getEInvoiceDetail";
	path = "invoices/:invoice_id";
	timeout = 2e5;
	/* c8 ignore next 7 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.e-invoice+xml"
		};
	}
}, Oi = class extends u {
	name = "getInvoice";
	path = "invoices/:id";
	property = "invoices";
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.invoice_normal+json"
		};
	}
}, ki = class extends u {
	method = "POST";
	name = "postBankTransactions";
	path = "billing/bank_transactions";
	property = "";
}, Ai = class extends u {
	method = "POST";
	name = "postInvoiceTransactions";
	path = "invoice_transactions";
	property = "transactions";
}, ji = class extends u {
	method = "POST";
	name = "postSurcharges";
	path = "surcharges/upload";
	property = "";
}, Mi = [
	new Oi(),
	new an(),
	new on(),
	new mn(),
	new Di(),
	new pn(),
	new fn(),
	new sn(),
	new hn(),
	new ki(),
	new cn(),
	new Ai(),
	new ln(),
	new ji(),
	new un(),
	new dn()
], Ni = [
	new gn(),
	new _n(),
	new vn()
], Pi = [new yn()], Fi = [new bn(), new xn()], Ii = [new Sn()], Li = [new Cn()], Ri = [new On()], zi = [new wn()], Bi = [new En()], Vi = [new Dn()], Hi = [new Tn()], Ui = [new class extends u {
	name = "getReturnReasons";
	path = "return_reasons";
	property = "return_reasons";
}()], Wi = [new kn()], Gi = [new class extends u {
	method = "POST";
	name = "postShipmentCredits";
	path = "shipment_credits";
	property = "shipment_credits";
}()], Ki = [new class extends u {
	name = "getShipmentLabels";
	path = "shipment_labels/:ids";
	responseProperty = "payment_instructions";
	/* c8 ignore start */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.shipment_label+pdf"
		};
	}
	timeout = 6e4;
}()], qi = class extends u {
	method = "DELETE";
	name = "deleteShipments";
	path = "shipments/:shipmentIds";
}, Ji = class extends u {
	method = "PATCH";
	name = "patchShipments";
	path = "shipments";
	property = "shipments";
	/* c8 ignore start */
	getHeaders() {
		return {
			...super.getHeaders(),
			"Content-Type": "application/vnd.shipment+json;charset=utf-8;version=1.1"
		};
	}
}, Yi = [
	new An(),
	new jn(),
	new Ji(),
	new Mn(),
	new qi()
], Xi = [
	new Ln(),
	new Nn(),
	new Pn(),
	new Fn(),
	new In()
], Zi = [new Rn(), new zn()], Qi = [
	new Bn(),
	new Vn(),
	new Hn(),
	new Un()
], $i = class extends u {
	method = "DELETE";
	name = "deleteShopImageLabel";
	path = "shops/:shop_id/images/label";
	property = "branding_banner";
}, ea = class extends u {
	method = "POST";
	name = "postShopImageLabel";
	path = "shops/:shop_id/images/label";
	property = "branding_banner";
	responseProperty = "ids";
}, ta = [
	new Wn(),
	new Gn(),
	new ea(),
	new $i()
], na = [
	new Kn(),
	new qn(),
	new Jn()
], ra = [new Yn()], ia = [
	new Xn(),
	new Zn(),
	new Qn()
], aa = [new $n()], oa = [new er()], sa = [new tr()], ca = [
	new nr(),
	new rr(),
	new ir(),
	new ar()
], la = [new or(), new sr()], ua = [new cr()], da = [new lr()], fa = [new ur()], pa = [new dr()], ma = class extends u {
	method = "GET";
	name = "getSystemMessage";
	path = "system_messages/:id";
	property = "messages";
}, ha = class extends u {
	name = "getSystemMessages";
	path = "system_messages";
	property = "messages";
}, ga = [
	new ma(),
	new ha(),
	new h(),
	new fr(),
	new pr()
], _a = [new mr()], va = [new hr()], ya = [new gr()], ba = [new _r()], xa = [
	new vr(),
	new yr(),
	new br()
], Sa = [
	new Sr(),
	new Cr(),
	new xr(),
	new wr(),
	new Tr()
], Ca = [new Er()], wa = [
	new Dr(),
	new Or(),
	new kr()
], Ta = [
	...Kr,
	...wa,
	...ui,
	...di,
	...ca,
	...sa,
	...pa,
	...Yi,
	...Ur,
	...Pi,
	...ni,
	...ba,
	...Br,
	...Vr,
	...Hr,
	...Wr,
	...qr,
	...Gr,
	...Jr,
	...Zr,
	...ti,
	...ri,
	...oi,
	...si,
	...ci,
	...li,
	...fi,
	...mi,
	...hi,
	...yi,
	...gi,
	...bi,
	...xi,
	...Ci,
	...wi,
	...Ti,
	...Ei,
	...Mi,
	...Fi,
	...Ii,
	...Li,
	...Bi,
	...Ri,
	...zi,
	...Wi,
	...Xi,
	...ia,
	...Zi,
	...Qi,
	...na,
	...ra,
	...aa,
	...ua,
	...da,
	...fa,
	...la,
	...ga,
	..._a,
	...ya,
	...va,
	...xa,
	...Sa,
	...Ca,
	...Vi,
	...Hi,
	...oa,
	...Yr,
	...Xr,
	...Zt,
	...ia,
	...Ui,
	...ii,
	...ta,
	...pi,
	...ai,
	..._i,
	...vi,
	...Gi,
	...Ki,
	...ei,
	...Ni
], Ea = Ta, g, _;
function Da() {
	return {
		sdk: g,
		initSdk: ({ token: e, baseUrl: t, initialLocale: n, getToken: r }) => {
			if (n && (_ = n), g) return g;
			let i = !e && !r, a = new te({
				baseUrl: t,
				headers: { ...e ? { Authorization: `Bearer ${e}` } : {} },
				...i ? { credentials: "include" } : {},
				options: { timeout: 8e3 }
			});
			a.interceptors.request.use(async (e) => {
				let t = localStorage.getItem("x-dmp-feature-flags");
				return e.headers = {
					"x-referer": window.location.href,
					..._ ? { "Accept-Language": _ } : {},
					...t ? { "x-dmp-feature-flags": t } : {},
					...e.headers,
					...r ? { Authorization: `Bearer ${await r()}` } : {}
				}, e;
			});
			let o = ie(a, Ea);
			return i && (a.requiredHeaders = []), g = o, g;
		},
		resetSdk: () => {
			g = void 0;
		},
		setAcceptLanguageHeader: (e) => {
			_ = e;
		}
	};
}
//#endregion
//#region src/endpoints/public/billing/domain.ts
var Oa = [new class extends d {
	name = "getPaymentStatus";
	path = "/billing/payment_status/:hash";
	property = "payment_status";
}()], ka = [new Lr(), new Ir()], Aa = [new Rr()], ja = [new class extends d {
	name = "getCheckUsername";
	path = "check_username";
}()], Ma = [new Ar()], Na = [new jr()], Pa = [new Mr()], Fa = [new class extends d {
	name = "getReturnReasonSettings";
	path = "consumer_portal/return_reason_settings";
	property = "return_reason_settings";
}()], Ia = class extends d {
	name = "getReturnShipment";
	path = "return_shipment/:hash";
	property = "return_shipments";
}, La = class extends d {
	method = "POST";
	name = "postReturnShipmentLabel";
	path = "return_shipment/email_label";
	property = "return_shipments";
}, Ra = class extends d {
	name = "getReturnShipmentReturnReason";
	path = "return_shipment/:hash/return_reasons";
	property = "return_reasons";
}, za = class extends d {
	method = "POST";
	name = "postReturnShipmentReturnComment";
	path = "return_shipment/:hash/return_comment";
	property = "return_comments";
}, Ba = class extends d {
	method = "POST";
	name = "postReturnShipmentReturnReasons";
	path = "return_shipment/:hash/return_reasons";
	property = "return_reasons";
}, Va = [
	new Ia(),
	new La(),
	new Ba(),
	new za(),
	new Ra()
], Ha = [new class extends d {
	method = "POST";
	path = "consumer_portal/return_shipments";
	name = "postReturnShipments";
	property = "return_shipments";
}()], Ua = class extends d {
	method = "PUT";
	name = "putSocialShippingLinks";
	path = "consumer_portal/social_shipping_links/:uuid";
	property = "social_shipping_links";
}, Wa = [new Nr(), new Ua()], Ga = [new zr()], Ka = [new class extends d {
	name = "getPhoneNumberCheck";
	path = "/phone_number/check";
	property = "phone_number";
}()], qa = [new Pr(), new Fr()], v = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20
}, y = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM"
};
v.Dhl, v.Instabox, v.PostNl, y.PostNl, v.Bpost, y.Bpost, v.CheapCargo, y.CheapCargo, v.Dpd, y.Dpd, v.Instabox, y.Instabox, v.Dhl, y.Dhl, v.Bol, y.Bol, v.Ups, y.Ups, v.DhlForYou, y.DhlForYou, v.DhlParcelConnect, y.DhlParcelConnect, v.DhlEuroPlus, y.DhlEuroPlus, v.UpsStandard, y.UpsStandard, v.UpsExpressSaver, y.UpsExpressSaver, v.Gls, y.Gls, v.Brt, y.Brt, v.Trunkrs, y.Trunkrs, v.InPost, y.InPost, v.PosteItaliane, y.PosteItaliane, v.Spring, y.Spring, v.ViaTim, y.ViaTim, v.PostNl, y.POSTNL, v.Bpost, y.BPOST, v.CheapCargo, y.CHEAP_CARGO, v.Dpd, y.DPD, v.Instabox, y.INSTABOX, v.Dhl, y.DHL, v.Bol, y.BOL, v.Ups, y.UPS, v.DhlForYou, y.DHL_FOR_YOU, v.DhlParcelConnect, y.DHL_PARCEL_CONNECT, v.DhlEuroPlus, y.DHL_EUROPLUS, v.UpsStandard, y.UPS_STANDARD, v.UpsExpressSaver, y.UPS_EXPRESS_SAVER, v.Gls, y.GLS, v.Brt, y.BRT, v.Trunkrs, y.TRUNKRS, v.InPost, y.INPOST, v.PosteItaliane, y.POSTE_ITALIANE, v.Spring, y.SPRING, v.ViaTim, y.VIA_TIM, y.PostNl, v.PostNl, y.POSTNL, v.PostNl, y.Bpost, v.Bpost, y.BPOST, v.Bpost, y.CheapCargo, v.CheapCargo, y.CHEAP_CARGO, v.CheapCargo, y.Dpd, v.Dpd, y.DPD, v.Dpd, y.Instabox, v.Instabox, y.Dhl, v.Dhl, y.BolCom, v.Bol, y.Bol, v.Bol, y.BOL, v.Bol, y.Ups, v.Ups, y.DhlForYou, v.DhlForYou, y.DHL_FOR_YOU, v.DhlForYou, y.DhlParcelConnect, v.DhlParcelConnect, y.DHL_PARCEL_CONNECT, v.DhlParcelConnect, y.DhlEuroPlus, v.DhlEuroPlus, y.DHL_EUROPLUS, v.DhlEuroPlus, y.UpsStandard, v.UpsStandard, y.UPS_STANDARD, v.UpsStandard, y.UpsExpressSaver, v.UpsExpressSaver, y.UPS_EXPRESS_SAVER, v.UpsExpressSaver, y.Gls, v.Gls, y.GLS, v.Gls, y.Brt, v.Brt, y.BRT, v.Brt, y.Trunkrs, v.Trunkrs, y.TRUNKRS, v.Trunkrs, y.InPost, v.InPost, y.INPOST, v.InPost, y.PosteItaliane, v.PosteItaliane, y.POSTE_ITALIANE, v.PosteItaliane, y.Spring, v.Spring, y.SPRING, v.Spring, y.ViaTim, v.ViaTim, y.VIA_TIM, v.ViaTim, v.PostNl, v.Bpost, v.CheapCargo, v.Dpd, v.Instabox, v.Dhl, v.Bol, v.Ups, v.DhlForYou, v.DhlParcelConnect, v.DhlEuroPlus, v.UpsStandard, v.UpsExpressSaver, v.Gls, v.Brt, v.Trunkrs, v.InPost, v.PosteItaliane, v.ViaTim;
var b = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
b.Austria, b.Belgium, b.Bulgaria, b.Croatia, b.Cyprus, b.CzechRepublic, b.Denmark, b.Estonia, b.Finland, b.France, b.Germany, b.Greece, b.Hungary, b.Ireland, b.Italy, b.Latvia, b.Lithuania, b.Luxembourg, b.Malta, b.Netherlands, b.Poland, b.Portugal, b.Romania, b.Slovakia, b.Slovenia, b.Spain, b.Sweden, Object.values(b), b.Angola, b.AntiguaAndBarbuda, b.Aruba, b.Bahamas, b.Belize, b.Benin, b.Bermuda, b.BonaireSintEustatiusAndSaba, b.Botswana, b.BurkinaFaso, b.Burundi, b.Cameroon, b.CanaryIslands, b.CentralAfricanRepublic, b.Comoros, b.CongoBrazzaville, b.CongoKinshasa, b.CoteDIvoire, b.Curacao, b.Djibouti, b.Dominica, b.DutchAntilles, b.EquatorialGuinea, b.Eritrea, b.Fiji, b.Gabon, b.Gambia, b.Ghana, b.Grenada, b.Guyana, b.HongKong, b.Kiribati, b.KoreaPeoplesDemocraticRepublic, b.Macao, b.Malawi, b.Mali, b.Mauritania, b.Nauru, b.Qatar, b.Rwanda, b.SaintKittsAndNevis, b.SaoTomeAndPrincipe, b.Seychelles, b.SierraLeone, b.SintMaarten, b.Suriname, b.SyrianArabRepublic, b.TimorLeste, b.Togo, b.Tonga, b.Tuvalu, b.Uganda, b.UnitedArabEmirates, b.Vanuatu, b.Yemen, b.Zimbabwe, b.Austria, b.Belgium, b.Bulgaria, b.Croatia, b.CzechRepublic, b.Estonia, b.Finland, b.France, b.Germany, b.Greece, b.Hungary, b.Ireland, b.Italy, b.Latvia, b.Lithuania, b.Luxembourg, b.Malta, b.Netherlands, b.Portugal, b.Romania, b.Slovakia, b.Slovenia, b.Spain, b.UnitedKingdom, b.Denmark, b.Germany, b.Sweden;
var x = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, S = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, C = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
x.EarlyMorning, S.EarlyMorning, x.Morning, S.Morning, x.Standard, S.Standard, x.Evening, S.Evening, x.Pickup, S.Pickup, x.PickupExpress, S.PickupExpress, x.SameDayDelivery, S.SameDayDelivery, x.Express, S.Express, S.EarlyMorning, x.EarlyMorning, S.Morning, x.Morning, S.Standard, x.Standard, S.Evening, x.Evening, S.Pickup, x.Pickup, S.PickupExpress, x.PickupExpress, S.SameDayDelivery, x.SameDayDelivery, S.Express, x.Express, x.EarlyMorning, C.EarlyMorning, x.Morning, C.Morning, x.Standard, C.Standard, x.Evening, C.Evening, x.Pickup, C.Pickup, x.PickupExpress, C.PickupExpress, x.SameDayDelivery, C.SameDayDelivery, x.Express, C.Express, C.EarlyMorning, S.EarlyMorning, C.Morning, S.Morning, C.Standard, S.Standard, C.Evening, S.Evening, C.Pickup, S.Pickup, C.PickupExpress, S.PickupExpress, C.SameDayDelivery, S.SameDayDelivery, C.Express, S.Express, x.EarlyMorning, x.Morning, x.Standard, x.Evening, x.Pickup, x.PickupExpress, x.SameDayDelivery, x.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var w = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, T = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
T.Sunday, w.Sunday, T.Monday, w.Monday, T.Tuesday, w.Tuesday, T.Wednesday, w.Wednesday, T.Thursday, w.Thursday, T.Friday, w.Friday, T.Saturday, w.Saturday, w.Sunday, T.Sunday, w.Monday, T.Monday, w.Tuesday, T.Tuesday, w.Wednesday, T.Wednesday, w.Thursday, T.Thursday, w.Friday, T.Friday, w.Saturday, T.Saturday;
var E = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
E.Bytes, E.Kilobytes, E.Megabytes, E.Gigabytes, E.Terabytes;
var D = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, O = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
D.Bol, O.Bol, D.Exact, O.Exact, D.Amazon, O.Amazon, D.Wix, O.Wix, D.ExactDe, O.ExactDe, D.Etsy, O.Etsy, O.Bol, D.Bol, O.Exact, D.Exact, O.Amazon, D.Amazon, O.Wix, D.Wix, O.ExactDe, D.ExactDe, O.Etsy, D.Etsy;
var k = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, A = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
k.Unpaid, A.Unpaid, k.Due, A.Due, k.DuePrepayment, A.DuePrepayment, k.Reminder1, A.Reminder1, k.Reminder2, A.Reminder2, k.Dun, A.Dun, k.Collection, A.Collection, k.Instalments, A.Instalments, k.PaymentArrangement, A.PaymentArrangement, k.Dispute, A.Dispute, k.LegalProcedure, A.LegalProcedure, k.Insolvency, A.Insolvency, k.WriteOff, A.WriteOff, k.Pending, A.Pending, k.Cancelled, A.Cancelled, k.Paid, A.Paid, k.PaidOnline, A.PaidOnline, k.PaidAutomatic, A.PaidAutomatic, k.PaidCredit, A.PaidCredit, k.PaidZeroItems, A.PaidZeroItems, k.InvoiceWith0InvoiceItemsPaidZeroBalance, A.PaidZeroBalance, k.Due, k.Reminder1, k.Reminder2, k.Dun, k.Collection, k.Instalments, k.PaymentArrangement, k.Dispute, k.Paid, k.PaidOnline, k.PaidAutomatic, k.PaidCredit, k.PaidZeroItems;
var Ja = {
	Gram: "g",
	Kilogram: "kg"
};
Ja.Gram, Ja.Kilogram;
var j = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
j.Millimeter, j.Centimeter, j.Meter;
var M = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, N = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
N.PendingConcept, N.PendingRegistered, N.EnRouteHandedToCarrier, N.EnRouteSorting, N.EnRouteDistribution, N.EnRouteCustoms, N.DeliveredReadyForPickup, N.DeliveredAtRecipient, N.DeliveredPackagePickedUp;
var P = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, F = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
F.Light, P.Light, F.Start, P.Start, F.Plus, P.Plus, F.Premium, P.Premium, F.Max, P.Max, P.Light, F.Light, P.Start, F.Start, P.Plus, F.Plus, P.Premium, F.Premium, P.Max, F.Max;
var I = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, L = {
	Start: P.Start,
	Plus: P.Plus,
	Premium: P.Premium,
	Max: P.Max
};
I.Start, L.Start, I.Plus, L.Plus, I.Premium, L.Premium, I.Max, L.Max, L.Start, I.Start, L.Plus, I.Plus, L.Premium, I.Premium, L.Max, I.Max;
var R = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, z = {
	Start: P.Start,
	Plus: P.Plus,
	Premium: P.Premium,
	Max: P.Max
};
R.Start, z.Start, R.Plus, z.Plus, R.Premium, z.Premium, R.Max, z.Max, z.Start, R.Start, z.Plus, R.Plus, z.Premium, R.Premium, z.Max, R.Max;
var B = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, V = {
	Light: P.Light,
	Start: P.Start,
	Plus: P.Plus,
	Premium: P.Premium,
	Max: P.Max
};
B.Light, V.Light, B.Start, V.Start, B.Plus, V.Plus, B.Premium, V.Premium, B.Max, V.Max, V.Light, B.Light, V.Start, B.Start, V.Plus, B.Plus, V.Premium, B.Premium, V.Max, B.Max;
var H = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, U = {
	Start: P.Start,
	Plus: P.Plus,
	Premium: P.Premium,
	Max: P.Max
};
H.Start, U.Start, H.Plus, U.Plus, H.Premium, U.Premium, H.Max, U.Max, U.Start, H.Start, U.Plus, H.Plus, U.Premium, H.Premium, U.Max, H.Max;
var W = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, G = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, K = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
W.MyParcel, G.MyParcel, W.Flespakket, G.Flespakket, W.SendMyParcel, G.SendMyParcel, W.MyParcelIt, G.MyParcelIt, W.DeliverDutch, G.DeliverDutch, W.PostNlPlugin, G.PostNlPlugin, W.MyParcel, K.MyParcelNl, W.Flespakket, K.MyParcelNl, W.SendMyParcel, K.MyParcelBe, W.MyParcelIt, K.MyParcelIt, W.DeliverDutch, K.DeliverDutch, W.PostNlPlugin, K.PostNlPlugin, K.MyParcelNl, W.MyParcel, K.MyParcelBe, W.SendMyParcel, K.MyParcelIt, W.MyParcelIt, K.MyParcelNl, M.HomeCountry, b.Netherlands, M.Eu, M.Row, b.Belgium, K.MyParcelBe, M.HomeCountry, b.Belgium, b.Netherlands, M.Eu, M.Row, K.MyParcelBe, M.HomeCountry, b.Belgium, M.Eu, M.Row, K.MyParcelNl, M.HomeCountry, b.Netherlands, M.Eu, M.Row, K.MyParcelNl, M.HomeCountry, b.Netherlands, b.Belgium, b.Luxembourg, v.Bpost, v.PostNl, v.DhlForYou, v.DhlParcelConnect, v.DhlEuroPlus, v.Ups, v.UpsStandard, v.UpsExpressSaver;
var q = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, J = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
q.Package, J.Package, q.Mailbox, J.Mailbox, q.Letter, J.Letter, q.DigitalStamp, J.DigitalStamp, q.Pallet, J.Pallet, q.PackageSmall, J.PackageSmall, q.Envelope, J.Envelope, J.Package, q.Package, J.Mailbox, q.Mailbox, J.Letter, q.Letter, J.DigitalStamp, q.DigitalStamp, J.Pallet, q.Pallet, J.PackageSmall, q.PackageSmall, J.Envelope, q.Envelope;
var Y = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
q.Package, Y.PACKAGE, q.Mailbox, Y.MAILBOX, q.Letter, Y.UNFRANKED, q.DigitalStamp, Y.DIGITAL_STAMP, q.Pallet, Y.PALLET, q.PackageSmall, Y.SMALL_PACKAGE, q.Envelope, Y.ENVELOPE, Y.PACKAGE, q.Package, Y.MAILBOX, q.Mailbox, Y.UNFRANKED, q.Letter, Y.DIGITAL_STAMP, q.DigitalStamp, Y.PALLET, q.Pallet, Y.SMALL_PACKAGE, q.PackageSmall, Y.ENVELOPE, q.Envelope, q.Package, q.Mailbox, q.Letter, q.DigitalStamp, q.Pallet, q.PackageSmall, q.Envelope;
var X = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
X.PendingConcept, X.PendingRegistered, X.EnrouteHandedToCarrier, X.EnrouteSorting, X.EnrouteDistribution, X.DeliveredAtCustoms, X.DeliveredAtRecipient, X.DeliveredPackagePickedUp, X.DeliveredReturnShipmentPackagePickedUp, X.DeliveredAtAgreedLocation, X.PrintedLetter, X.PrintedDigitalStamp, X.InactiveConcept, X.InactiveRegistered, X.InactiveEnrouteHandedToCarrier, X.InactiveEnrouteSorting, X.InactiveEnrouteDistribution, X.InactiveEnrouteCustoms, X.InactiveDeliveredAtRecipient, X.InactiveDeliveredReadyForPickup, X.InactiveDeliveredPackagePickedUp;
//#endregion
//#region src/endpoints/public/track-traces/domain.ts
var Ya = [new class extends d {
	name = "getTrackTraces";
	path = "tracktraces";
	property = "tracktraces";
}()], Xa = [
	...Ma,
	...Na,
	...Ya,
	...Pa,
	...Ha,
	...Va,
	...Oa,
	...Fa,
	...Wa,
	...qa,
	...ka,
	...Aa,
	...Ga,
	...ja,
	...Ka
], Z, Q;
function Za() {
	return {
		sdk: Z,
		initSdk: (e, t) => {
			if (t && (Q = t), Z) return Z;
			let n = new te({
				baseUrl: e,
				options: { timeout: 8e3 }
			});
			return n.interceptors.request.use((e) => {
				let t = localStorage.getItem("x-dmp-feature-flags");
				return e.headers = {
					"x-referer": window.location.href,
					"x-dmp-feature-flags": t ?? "",
					...Q ? { "Accept-Language": Q } : {},
					...e.headers
				}, e;
			}), Z = ae(n, Xa), Z;
		},
		setAcceptLanguageHeader: (e) => {
			Q = e;
		},
		resetSdk: () => {
			Z = void 0;
		}
	};
}
//#endregion
//#region src/test/index.ts
var $ = "test-url", Qa = "test-token", $a = () => {
	let { initSdk: e } = Da();
	return e({
		token: Qa,
		baseUrl: $
	});
}, eo = () => {
	let { initSdk: e } = Za();
	return e($);
}, to = {
	IDLE: "idle",
	PENDING: "pending",
	RESOLVED: "resolved",
	REJECTED: "rejected",
	Idle: "idle",
	Pending: "pending",
	Resolved: "resolved",
	Rejected: "rejected"
};
//#endregion
export { ue as DeleteAccountCarrierOption, de as DeleteAccountMessage, pe as DeleteAccountProductPrices, Te as DeleteAddress, Ee as DeleteAddresses, He as DeleteBrandingBannerImage, Ge as DeleteCarrierOptions, Ye as DeleteCollectTrip, Xe as DeleteCollectTripSchedule, ut as DeleteDimensionsPresets, mt as DeleteDirectDebitMandate, yt as DeleteExternalIntegrationsProviderCredentialsAmazon, Tt as DeleteExternalIntegrationsProviderCredentialsBol, kt as DeleteExternalIntegrationsProviderCredentialsEtsy, Nt as DeleteExternalIntegrationsProviderCredentialsExact, Lt as DeleteExternalIntegrationsProviderCredentialsExactDe, Ht as DeleteExternalIntegrationsProviderCredentialsWix, Ln as DeleteShippingRule, Un as DeleteShopCarrierOption, Wn as DeleteShopImageEmail, nr as DeleteSubscription, h as DeleteSystemMessages, xr as DeleteUser, Dr as DeleteWebhookSubscriptions, Zt as FulfilmentDomain, ve as GetAccount, oe as GetAccountActiveBrackets, se as GetAccountBrackets, fe as GetAccountMessages, me as GetAccountProductPrices, ge as GetAccountSupportCases, ye as GetAccounts, Se as GetAcl, we as GetAclRolesAdmin, Ce as GetAclRolesCustomer, De as GetAddress, Oe as GetAddresses, Me as GetAnalyticsDashboards, Ne as GetApiKeys, Fe as GetBaseProductPrices, p as GetBillingMethods, m as GetBracketRanges, Be as GetBrackets, Ar as GetBranding, Ue as GetCarrierConfigurations, Ke as GetCarrierOptions, Lr as GetChamberOfCommerceCompanies, Rr as GetCheckShopName, tt as GetCheckSubdomain, Ze as GetCollectTripDisabledDays, Qe as GetCollectTripSchedules, $e as GetCollectTrips, Ir as GetCompanyProfile, nt as GetConsumerPortalFields, it as GetDeliveryOptions, ot as GetDimensionsPreset, at as GetDimensionsPresets, dt as GetDirectDebitBanks, ft as GetDirectDebitMandate, ht as GetDropOffPoints, gt as GetEmails, vt as GetEoriNumberCheck, bt as GetExternalIntegrationsProviderCredentialsAmazon, Ct as GetExternalIntegrationsProviderCredentialsBol, Dt as GetExternalIntegrationsProviderCredentialsEtsy, jt as GetExternalIntegrationsProviderCredentialsExact, Ft as GetExternalIntegrationsProviderCredentialsExactDe, Bt as GetExternalIntegrationsProviderCredentialsWix, jr as GetFields, Qt as GetImplications, en as GetInterimInvoices, tn as GetInvitations, pn as GetInvoiceCsvAttachment, mn as GetInvoiceDetailAttachment, fn as GetInvoiceDetailLegacyAttachment, on as GetInvoiceDetails, sn as GetInvoiceItemCategories, hn as GetInvoiceShortAttachment, an as GetInvoices, gn as GetLabelPackagesStatus, yn as GetLocations, zr as GetLocationsPublic, bn as GetPackagings, Cn as GetPaymentGateways, On as GetPhoneNumberCheck, wn as GetPickupLocations, En as GetPostalCode, Mr as GetPostalCodePublic, Dn as GetPriceScaleBrackets, Tn as GetProductPrice, Kn as GetReturnContributions, Ie as GetSepaInstructions, An as GetShipment, jn as GetShipments, Nn as GetShippingRules, Xn as GetShop, Rn as GetShopAccess, Bn as GetShopCarrierOptions, Yn as GetShopStatistics, Nr as GetSocialShippingLinks, $n as GetSpecialInvoiceItems, er as GetStatisticsAffiliateCommission, rr as GetSubscriptions, tr as GetSubscriptionsCapabilities, or as GetSupportCase, cr as GetSupportCaseAttachment, ur as GetSupportCaseReturnReasons, dr as GetSystemCountryCodes, mr as GetSystemShipmentOptionPrices, _r as GetTrackAndTrace, vr as GetUiSettings, Sr as GetUser, Cr as GetUsers, Or as GetWebhookSubscriptions, _e as MyReturnsStatus, st as PatchDimensionsPresets, Pn as PatchShippingRule, ir as PatchSubscriptions, le as PostAccountCarrierOptions, he as PostAccountProductPrices, xe as PostAccountsAnonymize, ke as PostAddress, Pe as PostApiKeys, Ve as PostBrandingBannerImage, We as PostCarrierConfiguration, qe as PostCarrierOptions, et as PostConnectAffiliates, ct as PostDimensionsPresets, pt as PostDirectDebitMandate, ze as PostEmailCollectionAgencyReport, f as PostEmailUnpaidInvoices, zt as PostExternalIntegration, xt as PostExternalIntegrationsProviderCredentialsAmazon, wt as PostExternalIntegrationsProviderCredentialsBol, Ot as PostExternalIntegrationsProviderCredentialsEtsy, Mt as PostExternalIntegrationsProviderCredentialsExact, It as PostExternalIntegrationsProviderCredentialsExactDe, Vt as PostExternalIntegrationsProviderCredentialsWix, Wt as PostFulfilmentDisable, Gt as PostFulfilmentDisableAutosplit, Kt as PostFulfilmentDisablePicqer, qt as PostFulfilmentEnable, Jt as PostFulfilmentEnableAutosplit, Yt as PostFulfilmentEnablePicqer, Xt as PostFulfilmentMode, $t as PostInterimInvoices, nn as PostInvitation, cn as PostInvoiceItems, vn as PostLabelPackages, je as PostMarkCreditInvoices, xn as PostPackaging, Sn as PostPaymentInstructions, Pr as PostPreRegistration, _n as PostProcessLabelPackages, Fr as PostRegistration, qn as PostReturnContributions, Er as PostSendVerificationEmail, Le as PostSepaInstructionsCredit, Re as PostSepaInstructionsDebit, kn as PostShipmentCarrierPrice, Mn as PostShipments, Fn as PostShippingRule, zn as PostShopAccess, Vn as PostShopCarrierOptions, Zn as PostShopDuplicate, Gn as PostShopImageEmail, un as PostSpecialInvoices, ar as PostSubscriptions, lr as PostSupportCaseComment, ln as PostSurchargeUploadUrl, pr as PostSystemMessages, hr as PostTicket, gr as PostTicketAttachment, yr as PostUiSettings, wr as PostUsers, kr as PostWebhookSubscriptions, be as PutAccount, ce as PutAccountBrackets, Ae as PutAddress, Je as PutCarrierOptions, rt as PutConsumerPortalFields, lt as PutDimensionsPresets, _t as PutEmail, St as PutExternalIntegrationsProviderCredentialsAmazon, Et as PutExternalIntegrationsProviderCredentialsBol, At as PutExternalIntegrationsProviderCredentialsEtsy, Pt as PutExternalIntegrationsProviderCredentialsExact, Rt as PutExternalIntegrationsProviderCredentialsExactDe, Ut as PutExternalIntegrationsProviderCredentialsWix, rn as PutInvitation, dn as PutInvoices, Jn as PutReturnContributions, In as PutShippingRule, Qn as PutShop, Hn as PutShopCarrierOptions, sr as PutSupportCase, fr as PutSystemMessages, br as PutUiSettings, Tr as PutUsers, to as Status, Qa as TestToken, $ as TestUrl, Ta as domains, Ea as privateSdkDomains, eo as testPublicSdk, $a as testSdk, Za as usePublicSdk, Da as useSdk };
